document.addEventListener('DOMContentLoaded', function() {
  const collapsibleElements = document.querySelectorAll('.pdp-collapsible-content');
  collapsibleElements.forEach(function(element) {
    const theme = element.getAttribute('data-theme');
    
    if (theme === 'show_more') {
      initializeShowMore(element);
    } else {
      initializeAccordion(element);
    }
  });

  initPdpVariantSpecs();
});

/**
 * Re-renders variant-driven spec lists when the product variant select changes.
 */
function initPdpVariantSpecs() {
  const masterSelect = document.querySelector('#product-select');
  if (!masterSelect) return;

  const roots = document.querySelectorAll('[data-pdp-variant-specs]');

  const parseSpecsData = function (root) {
    const script = root.querySelector('[data-pdp-variant-specs-data]');
    if (!script || !script.textContent) return null;
    try {
      return JSON.parse(script.textContent.trim());
    } catch (e) {
      return null;
    }
  };

  const applyVariant = function (variantId) {
    const idStr = String(variantId);
    roots.forEach(function (root) {
      const data = parseSpecsData(root);
      const ul = root.querySelector('[data-pdp-specs-list]');
      if (!ul || !data) return;
      const rows = data[idStr];
      ul.dataset.variantId = idStr;
      renderSpecsList(ul, rows);
    });
  };

  masterSelect.addEventListener('change', function () {
    if (roots.length) applyVariant(masterSelect.value);

    const selectedOption = masterSelect.options[masterSelect.selectedIndex];
    const url = selectedOption?.dataset.setupInstructionsUrl || '';
    if (typeof updateSetupInstructionsLinks === 'function') {
      updateSetupInstructionsLinks(url);
    }
  });

  if (roots.length) applyVariant(masterSelect.value);
}

/**
 * @param {HTMLUListElement} ul
 * @param {unknown} rows
 */
function renderSpecsList(ul, rows) {
  ul.innerHTML = '';
  if (!rows || !Array.isArray(rows) || rows.length === 0) {
    return;
  }
  rows.forEach(function (row) {
    if (!row || typeof row !== 'object') return;
    const label = row.specification != null ? row.specification : row['specification'];
    const val = row.value != null ? row.value : row['value'];
    const li = document.createElement('li');
    li.className = 'pdp-collapsible-content__spec-item';
    if (label != null && label !== '') {
      const strong = document.createElement('strong');
      strong.className = 'pdp-collapsible-content__spec-title';
      strong.textContent = String(label);
      li.appendChild(strong);
    }
    if (val != null && val !== '') {
      const div = document.createElement('div');
      div.className = 'pdp-collapsible-content__feature-spec rte';
      div.textContent = typeof val === 'string' ? val : String(val);
      li.appendChild(div);
    }
    if (li.childNodes.length) {
      ul.appendChild(li);
    }
  });
}

function initializeAccordion(element) {
  const trigger = element.querySelector('.pdp-collapsible-content__trigger');
  const content = element.querySelector('.pdp-collapsible-content__content');
  const defaultState = element.getAttribute('data-default-state');

  if (!trigger || !content) return;
  
  // Initialize state
  let isExpanded = defaultState === 'expanded';
  element.setAttribute('data-expanded', isExpanded);
      
  // Add click event listener
  trigger.addEventListener('click', function() {
    toggleAccordion(element);
  });
}

function initializeShowMore(element) {
  const collapsibleContentInner = element.querySelector('.pdp-collapsible-content__inner');
  const showMoreButton = element.querySelector('.pdp-collapsible-content__show-more');
  
  if (!collapsibleContentInner || !showMoreButton) return;
    
  // Check if content is actually clamped
  checkIfClamped(element, collapsibleContentInner);
    
  // Add click event listener
  showMoreButton.addEventListener('click', function() {
    const isExpanded = element.getAttribute('data-show-more-expanded') === 'true';
    const newState = !isExpanded;
    
    element.setAttribute('data-show-more-expanded', newState ? 'true' : 'false');
    showMoreButton.setAttribute('aria-expanded', newState ? 'true' : 'false');
    showMoreButton.textContent = newState ? 'See Less' : 'See More';
  });
}

function toggleAccordion(element) {
  const trigger = element.querySelector('.pdp-collapsible-content__trigger');
  const content = element.querySelector('.pdp-collapsible-content__content');
  const isCurrentlyExpanded = element.getAttribute('data-expanded') === 'true';
  const newState = !isCurrentlyExpanded;
  
  // Update state
  element.setAttribute('data-expanded', newState);
  trigger.setAttribute('aria-expanded', newState);

  if (newState) {
    content.classList.add('pdp-collapsible-content__content--expanded');
  } else {
    if (element.getAttribute('data-expanded') === 'false') {
      content.classList.remove('pdp-collapsible-content__content--expanded');
    }
  }
}

function checkIfClamped(element, collapsibleContentInner) {
  // Compare scrollHeight (full content height) to clientHeight (visible height)
  // If scrollHeight is greater, content is being clamped
  const isClamped = collapsibleContentInner.scrollHeight > collapsibleContentInner.clientHeight;
  element.setAttribute('data-show-more-available', isClamped ? 'true' : 'false');
  
  return isClamped;
}